import { cloneElement, isValidElement } from 'react';

// Either returns the layoutGroups if they are defined or creates a default layout group array
export const getForecastDetailGroups = (details, layoutGroups) => {
  if (layoutGroups.length) return layoutGroups;
  return details.map((detail) => [detail.id]).filter(([detailId]) => Boolean(detailId));
};

// Gets the actual detail objects for each layout group using the names in the layoutGroups array which matches the detail.id values in the details array.
export const getResolvedForecastDetailGroups = (details, forecastDetailGroups) => {
  return forecastDetailGroups.map((group) =>
    group
      .map((groupItemName) => details.find((detail) => detail.id === groupItemName))
      .filter(Boolean),
  );
};

// Gets a unique key for each group container (e.g. 'temperature-humidity-windSpeed')
export const getGroupContainerKey = (resolvedGroup) => {
  return resolvedGroup.map((detail) => detail.id).join('-');
};

// Creates a new resized icon element with the specified size if the icon is a valid React element.
export const getSizedDetailIcon = (icon, iconSize) => {
  if (!iconSize || !isValidElement(icon)) return icon;

  return cloneElement(icon, {
    size: iconSize,
    style: {
      ...icon.props.style,
      width: iconSize,
      height: iconSize,
    },
  });
};
